<template>
  <footer class="relative border-t border-gray-100 bg-white">
    <div class="mx-auto max-w-7xl px-6 py-20 sm:py-24 lg:px-8">
      <div class="grid grid-cols-2 gap-8 lg:grid-cols-4">
        <div class="col-span-2">
          <nuxt-link to="/" class="inline-block">
            <img
              :alt="appLogoAlt"
              :src="appLogoUrl"
              class="h-9 w-auto"
            />
          </nuxt-link>

          <p class="mt-4 max-w-sm text-sm/6 text-gray-600">
            {{ appDescriptionShort }}
          </p>

          <address class="mt-4 not-italic text-sm/6 text-gray-600">
            <div class="font-semibold">{{ companyName }}</div>
            {{ companyAddress }}
          </address>

          <div class="mt-6 flex gap-x-4">
            <nuxt-link
              v-for="item in navSocialItems"
              :key="item.name"
              :to="item.href"
              target="_blank"
              class="text-gray-600 hover:text-brand-700 transition"
            >
              <span class="sr-only">{{ item.name }}</span>

              <icon
                :name="item.icon"
                class="size-5"
                aria-hidden="true"
              />
            </nuxt-link>
          </div>
        </div>

        <div>
          <h3 class="text-sm font-semibold text-gray-900">
            Produit
          </h3>

          <ul role="list" class="mt-4 space-y-3">
            <li
              v-for="item in navFooterProductItems"
              :key="item.name"
            >
              <nuxt-link
                :to="item.href"
                class="text-sm text-gray-600 bg-gradient-to-r from-current to-current bg-left-bottom bg-no-repeat bg-[length:0%_1px] transition-[background-size,color] duration-200 ease-out hover:bg-[length:100%_1px] hover:text-brand-700 active:text-brand-700 motion-reduce:transition-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
              >
                {{ item.name }}
              </nuxt-link>
            </li>
          </ul>
        </div>

        <div>
          <h3 class="text-sm font-semibold text-gray-900">
            Entreprise
          </h3>

          <ul role="list" class="mt-4 space-y-3">
            <li
              v-for="item in navFooterCompanyItems"
              :key="item.name"
            >
              <nuxt-link
                :to="item.href"
                class="text-sm text-gray-600 bg-gradient-to-r from-current to-current bg-left-bottom bg-no-repeat bg-[length:0%_1px] transition-[background-size,color] duration-200 ease-out hover:bg-[length:100%_1px] hover:text-brand-700 active:text-brand-700 motion-reduce:transition-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
              >
                {{ item.name }}
              </nuxt-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="mt-16 border-t border-gray-100 pt-8 flex flex-col sm:flex-row justify-between gap-y-4">
        <p class="text-xs text-gray-500">
          © {{ currentYear }} {{ companyName }}. Tous droits réservés.
        </p>

        <p class="text-xs text-gray-500">
          Qualité et fiabilité suisse.
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
// Native Date instead of shared-utils/datetime: luxon would add ~70 kB to every page.
const currentYear = new Date().getUTCFullYear()
</script>
